module.exports = __webpack_public_path__ + "img/1440.ab41da6f.jpg";